
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* YouTube Video Background */}
      <div className="fixed inset-0 w-full h-full z-0">
        <iframe
          src="https://www.youtube.com/embed/_VYRp2kpaJA?autoplay=1&mute=1&loop=1&playlist=_VYRp2kpaJA&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1"
          className="absolute inset-0 w-full h-full object-cover"
          style={{
            width: '100vw',
            height: '100vh',
            transform: 'scale(1.2)', // Scale up to hide YouTube interface
            transformOrigin: 'center center'
          }}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
        
        {/* Dark overlay for better content readability */}
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Navigation Bar - Moved to Right Side */}
      <nav className="absolute top-6 right-6 z-20">
        <div className="bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 p-4">
          <div className="flex flex-col space-y-4">
            <a href="/" className="text-white hover:text-blue-300 transition-colors cursor-pointer font-medium px-4 py-2 rounded-lg hover:bg-white/10">Home</a>
            <a href="/team" className="text-white hover:text-blue-300 transition-colors cursor-pointer font-medium px-4 py-2 rounded-lg hover:bg-white/10">Meet the Doctors</a>
            <a href="#services" className="text-white hover:text-blue-300 transition-colors cursor-pointer font-medium px-4 py-2 rounded-lg hover:bg-white/10">Services</a>
            <a href="#contact" className="text-white hover:text-blue-300 transition-colors cursor-pointer font-medium px-4 py-2 rounded-lg hover:bg-white/10">Contact</a>
          </div>
        </div>
      </nav>

      {/* Logo positioned on top left */}
      <div className="absolute top-6 left-6 z-20">
        <div className="bg-white/95 backdrop-blur-sm rounded-xl p-3 shadow-2xl border border-white/20 hover:bg-white transition-all duration-300">
          <img 
            src="https://static.readdy.ai/image/7c34e572229199a03c653ba249394690/8c2de251b6b4c8837c068d068c7378f0.jfif" 
            alt="Insurance Doctors Logo" 
            className="h-12 w-auto object-contain filter brightness-110 contrast-110"
          />
        </div>
      </div>

      {/* Animated floating elements with CSS animations */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Floating insurance icons with proper animations */}
        <div className="absolute top-1/4 left-1/4 animate-pulse" style={{ animation: 'bounce 3s ease-in-out infinite' }}>
          <div className="w-12 h-12 bg-blue-500/30 rounded-full flex items-center justify-center backdrop-blur-sm border border-blue-400/20">
            <i className="ri-shield-check-line text-blue-200 text-xl"></i>
          </div>
        </div>
        <div className="absolute top-1/3 right-1/4 animate-pulse" style={{ animation: 'bounce 4s ease-in-out infinite 1s' }}>
          <div className="w-16 h-16 bg-green-500/30 rounded-full flex items-center justify-center backdrop-blur-sm border border-green-400/20">
            <i className="ri-heart-pulse-line text-green-200 text-2xl"></i>
          </div>
        </div>
        <div className="absolute bottom-1/3 left-1/3 animate-pulse" style={{ animation: 'bounce 3.5s ease-in-out infinite 2s' }}>
          <div className="w-10 h-10 bg-purple-500/30 rounded-full flex items-center justify-center backdrop-blur-sm border border-purple-400/20">
            <i className="ri-car-line text-purple-200 text-lg"></i>
          </div>
        </div>
        <div className="absolute top-1/2 right-1/3 animate-pulse" style={{ animation: 'bounce 4.5s ease-in-out infinite 0.5s' }}>
          <div className="w-14 h-14 bg-orange-500/30 rounded-full flex items-center justify-center backdrop-blur-sm border border-orange-400/20">
            <i className="ri-home-heart-line text-orange-200 text-xl"></i>
          </div>
        </div>
        
        {/* Moving elements across screen */}
        <div className="absolute top-1/2 -left-20" style={{ animation: 'moveRight 8s linear infinite' }}>
          <div className="w-8 h-8 bg-blue-400/40 rounded-full flex items-center justify-center">
            <i className="ri-user-line text-white text-sm"></i>
          </div>
        </div>
        <div className="absolute top-2/3 -right-20" style={{ animation: 'moveLeft 10s linear infinite 3s' }}>
          <div className="w-6 h-6 bg-green-400/40 rounded-full flex items-center justify-center">
            <i className="ri-nurse-line text-white text-xs"></i>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          {/* Enhanced text with better contrast and shadows */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight text-white drop-shadow-2xl animate-fade-in-up opacity-0 animation-delay-200" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8), 0 0 20px rgba(0,0,0,0.5)' }}>
            Your Insurance Health
            <span className="block text-blue-300 drop-shadow-2xl">Requires Expert Care</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed text-gray-100 drop-shadow-lg animate-fade-in-up opacity-0 animation-delay-400" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.8)' }}>
            At The Insurance Doctors, we diagnose your coverage gaps and prescribe the perfect insurance treatment. From auto to life insurance, we provide comprehensive care for all your protection needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up opacity-0 animation-delay-600">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-xl whitespace-nowrap cursor-pointer shadow-2xl">
              Schedule Checkup
            </button>
            <button 
              onClick={() => window.REACT_APP_NAVIGATE('/login')}
              className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white px-8 py-4 rounded-lg text-lg font-bold transition-all duration-300 hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer shadow-2xl border-2 border-green-400 relative overflow-hidden group"
            >
              <span className="relative z-10 flex items-center">
                <i className="ri-user-line mr-2 text-xl"></i>
                Patient Portal
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-emerald-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
          </div>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {[
              {
                icon: "ri-stethoscope-line",
                title: "Expert Diagnosis",
                description: "25+ years of experience diagnosing and treating insurance needs",
                delay: "animation-delay-800"
              },
              {
                icon: "ri-hospital-line",
                title: "24/7 Emergency Care",
                description: "Round-the-clock insurance emergency support when you need it",
                delay: "animation-delay-1000"
              },
              {
                icon: "ri-medicine-bottle-line",
                title: "Perfect Prescription",
                description: "Customized insurance treatments at the best rates",
                delay: "animation-delay-1200"
              }
            ].map((item, index) => (
              <div key={index} className={`bg-white/15 backdrop-blur-md rounded-lg p-6 hover:bg-white/25 transition-all duration-300 hover:scale-105 animate-fade-in-up opacity-0 ${item.delay} border border-white/10 shadow-2xl`}>
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4 hover:bg-blue-500 transition-colors duration-300 shadow-lg">
                  <i className={`${item.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-semibold mb-2 text-white drop-shadow-lg">{item.title}</h3>
                <p className="text-gray-100 drop-shadow-md">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
